import { Col, Row, Spinner } from "react-bootstrap";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

interface LoadingExhibitionsProps {
    rows: number;
    cols: number;
    colSizes?: {
        xs?: number;
        sm?: number;
        md?: number;
        lg?: number;
        xl?: number;
    };
    withSpinner?: boolean;
}

const LoadingExhibitions = ({ rows = 1, cols = 1, colSizes, withSpinner = false }: LoadingExhibitionsProps) => {
    return (
        <>
            {withSpinner && <Spinner />}
            {Array.from({ length: rows }).map((_, rowIndex) => (
                <Row key={rowIndex}>
                    {Array.from({ length: cols }).map((_, colIndex) => (
                        <Col
                            className="mb-4"
                            key={colIndex}
                            xs={colSizes?.xs || 12}
                            sm={colSizes?.sm || 6}
                            md={colSizes?.md || 4}
                            lg={colSizes?.lg || 3}
                            xl={colSizes?.xl || 2}
                        >
                            <div>
                                <Skeleton height={20} count={1} style={{ marginTop: 4 }} />
                                <Skeleton height={223} width={"100%"} />
                                <Skeleton height={24} count={2} style={{ marginTop: 10 }} />
                            </div>
                        </Col>
                    ))}
                </Row>
            ))}
        </>
    );
};

export default LoadingExhibitions;
